export default __webpack_public_path__ + "static/media/settings.da6c56e3.gif";